export default {
  GET_REGIONS: state => state.regions,
  GET_DISTRICTS: state => state.districts,
  GET_STAGE_TYPES(state) {
    return state.stage_types.results
  },
  GET_CURRENCIES(state) {
    return state.currencies.results
  },
  GET_APARTMENT_MATERIALS: state => state?.apartment_materials?.results,
  GET_PREMISES_DECORATIONS: state => state.premises_decorations.results,
  GET_FLAT_DECORATIONS: state => state?.flat_decorations?.results,
  GET_CONSTRUCTION_STAGES: state => state?.construction_stages?.results,
  GET_PLANNING_TYPES: state => state?.planning_types?.results,
  GET_OUTPUT_WINDOWS: state => state?.output_windows?.results,
  GET_QUARTERS: state => state?.quarters?.results,
  GET_MONTHS: state => state?.months.reverse(),
  GET_APARTMENT_TYPES: state => state?.apartment_types?.results,
  GET_FLAT_STATUSES: state => state.flat_statuses.results,
  GET_CONSTRUCTION_TYPES: state => state?.contruction_types?.results,
  GET_FLAT_LIVING_AREA_TYPES: state => state?.flat_living_area_types,
  GET_FLAT_NONLIVING_AREA_TYPES: state => state?.flat_nonliving_area_types,
  GET_OCCUPIED_BY_LIST: state => state.occupied_by_list,
  GET_SALE_OFFICES: state => state.sale_offices,
  GET_CONSTRUCTORS: state => state.constructors.results,
  GET_PAYMENT_INTERESTS: state => state.payment_interests,
  GET_PAYMENT_METHODS: state => state.payment_methods.results,
  GET_ONE_CONSTRUCTOR: state => state.single_constructor,
  GET_PROJECT_STAFF: state => state.project_staff,
}
